import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=728f2a78&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=728f2a78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728f2a78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('728f2a78')) {
      api.createRecord('728f2a78', component.options)
    } else {
      api.reload('728f2a78', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=728f2a78&scoped=true&", function () {
      api.rerender('728f2a78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personalCenter/order/detail.vue"
export default component.exports